/* eslint-disable react-hooks/exhaustive-deps */
import { FilterBar, FormGroup, Label, TextField, Select } from '@celltrak/ui-components';

import { visitTypeOptions } from '../../constants';

import useBusinessFilterBar from './hooks';

function BusinessFilterBar() {
  const {
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    handleEnterPress,
    filters,
    partnersOptions,
    aggregatorsOptions,
  } = useBusinessFilterBar();

  return (
    <FilterBar
      onPrimaryClick={() => handleResetFilter()}
      buttonSize="sm"
      showPrimaryButton={showResetButton}
      showSecondaryButton={false}
      primaryButtonLabel="Reset"
    >
      <FormGroup>
        <Label for="date-start-filter" size="sm">
          Start Date
        </Label>
        <TextField
          id="date-start-filter"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.startDate}
          onChange={handleFilterChanges('startDate')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="date-end-filter" size="sm">
          End Date
        </Label>
        <TextField
          id="date-end-filter"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.endDate}
          onChange={handleFilterChanges('endDate')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="partner-filter" size="sm">
          Partner
        </Label>
        <Select
          id="partner-filter"
          size="sm"
          options={partnersOptions}
          value={filters.partnerID}
          onChange={handleFilterChanges('partnerID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="node-filter" size="sm">
          Node
        </Label>
        <Select
          id="node-filter"
          size="sm"
          options={aggregatorsOptions}
          value={filters.aggregatorID}
          onChange={handleFilterChanges('aggregatorID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="visit-type-filter" size="sm">
          Visit Type
        </Label>
        <Select
          id="visit-type-filter"
          size="sm"
          options={visitTypeOptions}
          value={filters.visitStatus}
          onChange={handleFilterChanges('visitStatus')}
        />
      </FormGroup>
    </FilterBar>
  );
}

export default BusinessFilterBar;
